import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { TokenAPI } from '../../../Commonprovider/CommonProvider';



export const AuthApi = createAsyncThunk("authapi", async (Data) => {
    var urlencoded = new URLSearchParams();
    urlencoded.append("test", "Abc");
    urlencoded.append("grant_type", "password");
    urlencoded.append("username", Data.username);
    urlencoded.append("password", Data.Password);
    urlencoded.append("logintype", Data.logintype || undefined);
    urlencoded.append("otp", Data.otpvalue ?? undefined);
    urlencoded.append("isOtpUser", Data.otpuser ?? undefined);
    urlencoded.append("client_id", Data.Userid || undefined);
    urlencoded.append("test2", "Abc");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
    };
    const response = await fetch(`${TokenAPI}`, requestOptions)
    return response.json()
})



let initialState = {
    token: null,
    error: false,
    loading: false
}

export const Authenticationslice = createSlice({
    name: "authapi",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(AuthApi.fulfilled, (state, action) => {
            state.token = action.payload
            state.error = false
            state.loading = false
        })
        builder.addCase(AuthApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(AuthApi.rejected, (state, action) => {
            state.error = action.payload
            state.loading = false
        })
    }
})


export default Authenticationslice.reducer 